import React from "react";
import { resolveImage } from "../utils/imageLoader";
import EvidenceGallery from "./EvidenceGallery";

/**
 * Tarjeta de proyecto/actividad con evidencia fotográfica agrupada:
 * portada + descripción + mini-grid con lightbox de las fotos secundarias.
 * Usada en la sección "Mejoras" (Projects) para mostrar cada actividad de
 * campo sin volver la página una galería infinita de fotos sueltas.
 */
const EvidenceProjectCard = ({ project }) => {
  const secondaryImages = project.images.filter(
    (img) => img.src !== project.cover
  );

  return (
    <article className="bg-neutral-lightest rounded-lg shadow-lg overflow-hidden flex flex-col">
      <img
        src={resolveImage(project.cover)}
        alt={project.images.find((img) => img.src === project.cover)?.alt || project.title}
        loading="lazy"
        className="w-full h-48 md:h-56 object-cover"
      />
      <div className="p-6 flex flex-col gap-4 flex-1">
        <div>
          <span className="inline-block mb-2 px-3 py-1 text-xs font-semibold uppercase tracking-wide rounded-full bg-secondary-light text-primary">
            {project.category}
          </span>
          <h3 className="text-2xl font-semibold text-primary mb-2">{project.title}</h3>
          <p className="text-secondary-light">{project.description}</p>
        </div>
        {secondaryImages.length > 0 && (
          <div className="mt-auto">
            <EvidenceGallery items={secondaryImages} />
          </div>
        )}
      </div>
    </article>
  );
};

export default EvidenceProjectCard;
